import { Component, Prop, Mixins } from 'vue-property-decorator'

import MixinInterface from '@/_mixins/index'

import Avatar from '@/components/Avatar/User/Avatar.vue'
import UserAvatar from '@/_components/avatar/user/user.vue'

@Component({
    components: { Avatar, UserAvatar },
})
export default class UserListItem extends Mixins<MixinInterface>() {
    @Prop({ default: 30 }) size!: number

    get employerH() {
        return this.currentUser?.relationships?.employer?.data?.id
            ? this.$store.getters.userCompany?.name
            : this.$t('user_menu.no_company')
    }
}
